import i18next from 'i18next';
import { initReactI18next, getI18n } from 'react-i18next';
import enTrans from './translations/en.json';
import plTrans from './translations/pl.json';

export enum ATSLanguage {
    EN,
    PL,
}

export const ATSLanguageCode = {
    [ATSLanguage.EN]: 'en',
    [ATSLanguage.PL]: 'pl',
};

/**
 * Returns currently selected language code (e.g. `en`).
 */
export function getCurrentLangCode(): string {
    const i18n = getI18n();

    // if i18n is already initialized, lang should be set there
    if (i18n) {
        return i18n.languages[0];
    }

    // if i18n is not yet initialized, try to set the lang from navigator
    const navigatorLang = getLangCodeFromNavigator();
    if (navigatorLang) {
        return navigatorLang;
    }

    // return default value
    return ATSLanguageCode[0];
}

/**
 * Returns currently selected language ID.
 */
export function getCurrentLangId(): ATSLanguage {
    const i18n = getI18n();

    // return lang based on i18n or if it is not initialized yet return default value
    switch ((i18n && i18n.languages[0]) || ATSLanguageCode[0]) {
        case 'pl':
            return ATSLanguage.PL;
        default:
            return ATSLanguage.EN;
    }
}

function getLangCodeFromNavigator(): string | undefined {
    if (navigator) {
        const lang = navigator.language;

        if (lang && lang.length >= 2) {
            return lang.substr(0, 2).toLowerCase();
        }
    }
}

i18next
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        lng: getCurrentLangCode(),
        fallbackLng: ATSLanguageCode[0],
        debug: !process.env.NODE_ENV || process.env.NODE_ENV === 'development',
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        resources: {
            en: { translation: enTrans },
            pl: { translation: plTrans },
        },
    });
